<template>
  <div class="is-border-top has-bg-white is-padding">
    <div class="columns is-gapless">
      <div class="column columns is-gapless"
           :class="{'has-content-disabled': !parking.isCheck}"
      >
        <div class="column">
          <r-label v-if="parking.isCheck" :value="parking.sale_price_ht" :label="prixHt"
                   :redCheck='true'></r-label>
          <label v-else :for="`parkig_sale_price_ht_${index}`" class="label">Prix parking {{parking.annex_type}} HT <span v-if="parking.info">({{parking.info}})</span></label>
          <div class="field has-addons">
            <p class="control is-expanded">
              <v-input :id="`parkig_sale_price_ht_${index}`" :name="`parkig_sale_price_ht_${index}`" @input="val => updateSalePriceHt(val)"
                       :errors-bag="errors" data-vv-value-path="val" classes="has-text-right"
                        input-type="number"
                       data-vv-as=" " v-validate="'required|decimal:2'" :model="parking.sale_price_ht"
                       :disabled="!parking.isCheck" :number="true"
              >
              </v-input>
            </p>
            <div class="control"><a class="button is-static is-border is-square"><b class="">{{$currency}}&nbsp;HT</b></a></div>
          </div>
        </div>
        <div class="column is-narrow w110p is-padding-left-small is-padding-right-small">
          <r-label v-if="parking.isCheck" :redCheck='true' :label="'Tva'" :value="parking.tva"></r-label>
          <label v-else for="sale_price" class="label">Tva</label>
          <div v-if="parking.isCheck" class="select is-transparent is-paddingless-left">
            <select class="has-text-weight-medium" v-model.number="parking.tva"
                    @change="updateTva(parking.tva, parking.sale_price, null)">
              <option :value="20.0">20.0%</option>
              <option :value="10.0">10.0%</option>
              <option :value="7.0">7.0%</option>
              <option :value="5.5">5.5%</option>
              <option :value="0">0%</option>
            </select>
          </div>
          <div v-else class="has-text-black-ter has-text-weight-medium">
            20%
          </div>
          <div class="has-text-weight-light has-text-black-ter is-size-6" v-if="tvaAmount">
            ({{tvaAmount | prettyPrice}} {{$currency}})
          </div>
        </div>
        <div class="column">
          <r-label v-if="parking.isCheck" :label="prixTTC" :value="parking.sale_price"
                   :redCheck='true'></r-label>
          <label v-else :for="`parkig_sale_price_${index}`" class="label">Prix parking {{parking.annex_type}} TTC <span v-if="parking.info">({{parking.info}})</span></label>
          <div class="field has-addons">
            <p class="control is-expanded">
              <v-input :id="`parkig_sale_price_${index}`" :name="`parkig_sale_price_${index}`" @input="val => updateSalePrice(val)"
                        input-type="number"
                       :errors-bag="errors" data-vv-value-path="val" classes="has-text-right"
                       data-vv-as=" " v-validate="'required|decimal:2'" :model='parking.sale_price'
                       :disabled="!parking.isCheck" :number="true"
              >
              </v-input>
            </p>
            <div class="control"><a class="button is-static is-border is-square"><b class="">{{$currency}}&nbsp;TTC</b></a></div>
          </div>
        </div>
      </div>
      <div class="column is-narrow w50p is-padding-left-xsmall">
        <label for="" class="label is-margin-bottom-small">&nbsp;</label>
        <div class="field is-padding-top-xsmall">
          <input type="checkbox" :id="'check_parking' + index" :value="'check_parking' + index"
                 v-model="parking.isCheck" class="switch is-rounded is-success">
          <label :for="'check_parking' + index">&nbsp;</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { debounce } from 'lodash'

  export default {
    name: 'ParkingItemResa',
    data () {
      return {
        tvaAmount: null
      }
    },
    props: {
      source: {
        type: Object,
        required: true
      },
      index: {
        type: Number
      }
    },
    computed: {
      parking () {
        return this.source
      },
      prixHt () {
        return 'Prix parking ' + this.parking.annex_type + ' HT ' + (this.parking.info ? '(' + this.parking.info + ')' : '')
      },
      prixTTC () {
        return 'Prix parking ' + this.parking.annex_type + ' TTC ' + (this.parking.info ? '(' + this.parking.info + ')' : '')
      }
    },
    methods: {
      updateSalePriceHt: debounce(function (valSalePriceHt) {
        let salePriceTTC, salePriceHT
        if (!this.parking.sale_price_ht || Number(valSalePriceHt) !== Number(this.parking.sale_price_ht)) {
          salePriceHT = valSalePriceHt
          salePriceTTC = salePriceHT * (1 + (this.parking.tva / 100))
          salePriceTTC = salePriceTTC.toFixed(2)
          this.updatePrice(salePriceTTC, salePriceHT)
        }
      }, 500),
      updateTva (val) {
        if (val) this.$set(this.parking, 'tva', val)
        let tva = this.parking.tva

        let salePriceTTC = Number(this.parking.sale_price)
        let salePriceHT = Number(this.parking.sale_price_ht)

        if (!salePriceTTC && salePriceHT) {
          salePriceTTC = salePriceHT * (1 + (tva / 100))
          salePriceTTC = salePriceTTC.toFixed(2)
        } else {
          salePriceHT = salePriceTTC / (1 + (tva / 100))
          salePriceHT = salePriceHT.toFixed(2)
        }
        this.updatePrice(salePriceTTC, salePriceHT)
      },
      updateSalePrice: debounce(function (valSalePrice) {
        let salePriceTTC, salePriceHT
        if (!this.parking.sale_price || Number(valSalePrice) !== Number(this.parking.sale_price)) {
          salePriceTTC = valSalePrice
          salePriceHT = salePriceTTC / (1 + (this.parking.tva / 100))
          salePriceHT = salePriceHT.toFixed(2)
          this.updatePrice(salePriceTTC, salePriceHT)
        }
      }, 500),
      updatePrice (salePriceTTC, salePriceHT) {
        this.$set(this.parking, 'sale_price', salePriceTTC)
        this.$set(this.parking, 'sale_price_ht', salePriceHT)
        this.$set(this, 'tvaAmount', Number(this.parking.sale_price) - Number(this.parking.sale_price_ht))
      }
    },
    created () {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/option/ParkingItemResa.vue